interface VideoPlayerProps {
  src: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  playsInline?: boolean;
  className?: string;
  onEnded?: VoidFunction;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  src,
  autoPlay = true,
  loop = true,
  muted = true,
  playsInline = true,
  className = '',
  onEnded,
}: VideoPlayerProps) => {
  return (
    <video autoPlay={autoPlay} loop={loop} muted={muted} playsInline={playsInline} className={className} onEnded={onEnded}>
      <source src={src} type='video/mp4' />
      <track kind='captions' src='' label='English' />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;
